module.exports = __webpack_public_path__ + "683af0c33a709cafe614172d22fd1efc.svg";